import { themeDark2, Theme } from '@redislabsdev/redis-ui-styles';

export const themeUi: Theme = themeDark2;
